'use client';

import React from 'react';

import Markdown from '@components/utils/Markdown';

import {
  DateContainerMobile,
  DateHeader,
  DateLabel,
  DateSection,
  DateValue,
  Description,
  Separate,
  Wrapper,
} from './styled';
import { formatValidTourDate } from './utils';

interface TourDatesProps {
  departureDate?: string;
  arrivalDate?: string;
  departureDescription?: string;
  arrivalDescription?: string;
}

const TourDatesMobile: React.FC<TourDatesProps> = ({
  departureDate,
  arrivalDate,
  departureDescription,
  arrivalDescription,
}) => {
  const formattedDepartureDate = formatValidTourDate(departureDate);
  const formattedArrivalDate = formatValidTourDate(arrivalDate);

  if (!formattedDepartureDate && !formattedArrivalDate) return null;

  return (
    <Wrapper>
      <DateContainerMobile>
        {formattedDepartureDate ? (
          <DateSection>
            <DateHeader>
              <DateLabel>Gidiş Tarihi</DateLabel>
              <DateValue>{formattedDepartureDate}</DateValue>
            </DateHeader>
            {departureDescription ? (
              <Description>
                <Markdown text={departureDescription} />
              </Description>
            ) : null}
          </DateSection>
        ) : null}
        {formattedDepartureDate && formattedArrivalDate ? <Separate /> : null}
        {formattedArrivalDate ? (
          <DateSection>
            <DateHeader>
              <DateLabel>Dönüş Tarihi</DateLabel>
              <DateValue>{formattedArrivalDate}</DateValue>
            </DateHeader>
            {arrivalDescription ? (
              <Description>
                <Markdown text={arrivalDescription} />
              </Description>
            ) : null}
          </DateSection>
        ) : null}
      </DateContainerMobile>
    </Wrapper>
  );
};

export default TourDatesMobile;
